import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import check from "../../assets/check.svg";
import PopupComponent from "../../common/Popup";
import termsNConditions from "../../assets/Terms_Conditions_of_Sale.pdf";
import { create_orders } from "../../actions/orders";
import _ from "lodash";

const OriginSummary = ({ step, origin, selectedAddressId, isChecked, setIsChecked }) => {
  const dispatch = useDispatch();
  const [isAggree, setIsAggree] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showAddr, setShowAddr] = useState(false);
  const originId = origin?.origin_id;
  const checkedAddresses = isChecked[originId] || {};

  const toggleAddress = (addressId) => {
    setIsChecked(prev => ({
      ...prev,
      [originId]: {
        ...(prev[originId] || {}),
        [addressId]: !prev?.[originId]?.[addressId]
      }
    }));
  };

  const profile = useSelector(
    (state) => state?.auth?.profile?.data?.customer
  );
  const cart = useSelector((state) => state?.orders?.cart?.data?.cart);
  const createOrder = useSelector((state) => state?.orders?.createOrder);
  const addresses = useSelector((state) => state?.orders?.addresses?.data);

   const finalSelectedAddressId =
      selectedAddressId || origin?.shipping_address_id;
      console.log("finalSelectedAddressId", finalSelectedAddressId);

    const selected = addresses?.find(
      a => a.id === finalSelectedAddressId
    );

    const uniqueBySapRef = _.unionBy(addresses ?? [], "sap_ref");  
    const otherAddresses = uniqueBySapRef.filter(
        (a) =>
          a.id !== finalSelectedAddressId &&
          a.kunn2 !== selected?.kunn2
      );



  const vtweg =
    (origin?.origin_name === "ARLINGTON WAREHOUSE" && "41") ||
    cart?.order_type?.toUpperCase() === "FTL"
      ? "41"
      : "10";

  const payment = profile?.vtweg_data?.find(
    (ele) => ele.vtweg === vtweg
  );

  return (
    <div className="summary-terms addresses">

      {/* ===== ROW : PAYMENT + INCOTERMS single line) ===== */}
      <div className="summary-row inline-terms-5050">
        <div className="term-item">
          <span className="label">Payment Terms:</span>
          <span className="value">
            {localStorage.getItem("payment_term")}
          </span>
        </div>

        <div className="term-item">
          <span className="label">Incoterms:</span>
          <span className="value">
            {localStorage.getItem("delivery_term")}
          </span>
        </div>
      </div>
      {/* ===== ROW : ADDRESS + */}
      <div className="summary-row">

        {/* DELIVERY ADDRESS */}
        <div className="summary-col address-col">
          <label>Delivery Address</label>

          {step === 1 && addresses?.length > 0 && (
            <div className="diff-location">
              {showAddr ? (
                <span className="check" onClick={() => setShowAddr(false)}>
                  <img alt="check" src={check} />
                </span>
              ) : (
                <span
                  className="uncheck"
                  onClick={() => setShowAddr(true)}
                />
              )}
              <p className="address-note">
                Would you like to place the same order for different location ?
              </p>
            </div>
          )}

          {showAddr && (
            <>
              <label>Other Address</label>
                      {otherAddresses.map((item) => (
                  <div className="address" key={item.id}>
                    {checkedAddresses[item.id] ? (
                      <span
                        className="check"
                        onClick={() =>
                           toggleAddress(item.id)
                        }
                      >
                        <img alt="check" src={check} />
                      </span>
                    ) : (
                      <span
                        className="uncheck"
                        onClick={() =>
                          toggleAddress(item.id)
                        }
                      />
                    )}
                    <span className="addr">
                      {item.name}
                      <br />
                      {item?.address1 && <>{item.address1},<br /></>}
                      {item?.address2 && <>{item.address2},<br /></>}
                      {item?.city && <>{item.city},<br /></>}
                      <br /> {item?.state} {item?.zip}
                    </span>
                  </div>
                ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OriginSummary;
